module.exports = __webpack_public_path__ + "img/shop2.9b179b9e.jpg";